import { gql } from "@apollo/client";

const EXPORT_STATUS_QUERY = gql`
  query export_status(
    $group_by: String
    $name: String
    $project: String
    $lookback_days: Int
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    export_status(
      group_by: $group_by
      name: $name
      project: $project
      lookback_days: $lookback_days
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          name
          project
          status
          credential {
            name
            status
          }
          journal {
            date
            running
            completed
            failed
            total_rows
            min_rows
            max_rows
            total_bytes
            min_bytes
            max_bytes
          }
        }
      }
    }
  }
`;

const IMPORT_STATUS_QUERY = gql`
  query import_status(
    $group_by: String
    $name: String
    $project: String
    $lookback_days: Int
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    import_status(
      group_by: $group_by
      name: $name
      project: $project
      lookback_days: $lookback_days
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          name
          status
          project
          credential {
            name
            status
          }
          journal {
            date
            running
            completed
            failed
            total_rows
            min_rows
            max_rows
            total_bytes
            min_bytes
            max_bytes
            dirty_rows
          }
        }
      }
    }
  }
`;

export { EXPORT_STATUS_QUERY, IMPORT_STATUS_QUERY };
